import type { RootState } from '@portal-types/store';

export const downloading = (state: RootState) => state.downloadArea.data?.downloading;
export const reportList = (state: RootState) => state.downloadArea.data?.reportList;
